import { indexOf } from 'lodash'

export default {
    props: {
        id: {
            required: true,
            type: String,
        },
        value: {
            type: Object,
            required: false,
            default: _ => null,
        },
        htmlId: {
            required: false,
            type: String,
            default: _ => null,
        },
        propertyType: {
            required: false,
            type: Object,
            default: _ => {return {}},
        },
        meta: {
            required: false,
            type: Object,
            default: _ => {return {}},
        },
        lock: {
            required: false,
            type: Object,
            default: _ => {return {}},
        },
        visibility: {
            required: false,
            type: Number,
            default: _ => 0,
        },
        editType: {
            required: false,
            type: String,
            default: _ => 'edit',
            validator: value => {
                if (indexOf(['edit', 'new'], value) === -1) {
                    console.warn('editType MUST be one of [new, edit]')
                    return false
                }
                return true
            },
        },
    },
}
